import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeParticipant, removeParticipant } from 'focus_groups/ducks/view_state';

import ParticipantRow from 'focus_groups/components/participant_row';

export function mapStateToProps() {
  return {};
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onChange: changeParticipant,
    onRemove: removeParticipant,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantRow);



// WEBPACK FOOTER //
// ./focus_groups/containers/participant_row.js